(function (root, factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory;
  if (root && root.document) factory(root, root.document, root.navigator, root.PonoAnalyticsCapture || {});
})(typeof window !== 'undefined' ? window : this, function (window, document, navigator, config) {
  if (!document || (!config.incidentMode && !config.monitoring)) return;
  var Blob = window.Blob;
  var fetch = window.fetch.bind(window);  var REQUEST_ID = config.requestId;
  var BASE_PATH = config.path;
  var PAGE_TYPE = config.pageType;
  var PAGE_ID = config.pageId;
  var WEBSITE_PERFORMANCE_MONITORING = config.monitoring;
  var startedAt = Date.now();
  var visibleStart = document.visibilityState === 'visible' ? monotonicNow() : null;
  var engagedMs = 0;
  var maxScrollPercent = 0;
  var lastActivity = monotonicNow();
  var lastTick = lastActivity;
  var hiddenSent = false;
  var copyEventSent = false;
  var formStarts = typeof WeakSet !== 'undefined' ? new WeakSet() : null;
  var formStartFallback = [];
  var counts = {
    copy: 0,
    print: 0,
    outbound: 0,
    app: 0,
    cta: 0,
    mailto: 0,
    tel: 0,
    download: 0,
    form: 0
  };

  function truncate(value, max) {
    if (value === null || typeof value === 'undefined') return null;
    value = String(value);
    max = max || 255;
    return value.length > max ? value.slice(0, max) : value;
  }

  function monotonicNow() {
    try {
      return window.performance && typeof window.performance.now === 'function'
        ? window.performance.now()
        : Date.now();
    } catch (e) {
      return Date.now();
    }
  }

  function laravelPath() {
    if (BASE_PATH) return BASE_PATH;
    var path = window.location.pathname || '/';
    path = path.replace(/^\/+/, '');
    return path === '' ? '/' : path;
  }

  function basePayload(eventType) {
    return {
      browser_proof: config.proof || undefined,
      event_id: eventId(),
      request_id: REQUEST_ID,
      path: laravelPath(),
      page_title: truncate(document.title || ''),
      page_type: PAGE_TYPE,
      page_id: PAGE_ID,
      event_type: eventType
    };
  }

  function eventId() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') return window.crypto.randomUUID();
    if (!window.crypto || !window.crypto.getRandomValues) return undefined;
    var bytes = window.crypto.getRandomValues(new Uint8Array(16));
    bytes[6] = (bytes[6] & 15) | 64;
    bytes[8] = (bytes[8] & 63) | 128;
    var hex = Array.from(bytes, function (b) { return b.toString(16).padStart(2, '0'); }).join('');
    return hex.slice(0,8)+'-'+hex.slice(8,12)+'-'+hex.slice(12,16)+'-'+hex.slice(16,20)+'-'+hex.slice(20);
  }

  function sendEvent(eventType, data) {
    try {
      var payload = basePayload(eventType);
      data = data || {};
      Object.keys(data).forEach(function (key) {
        payload[key] = data[key];
      });

      payload.metadata = payload.metadata || {};
      if (typeof payload.metadata.last_activity_age_ms === 'undefined') {
        payload.metadata.last_activity_age_ms = Math.max(0, Math.floor(monotonicNow() - lastActivity));
      }
      var body = JSON.stringify(payload);
      if (navigator.sendBeacon) {
        var blob = new Blob([body], { type: 'application/json' });
        if (navigator.sendBeacon('/visitorlog/event', blob)) return;
      }

      fetch('/visitorlog/event', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: body,
        keepalive: true,
        credentials: 'same-origin'
      }).catch(function () {});
    } catch (e) {}
  }

  function dimensionsMetadata() {
    return {
      viewport_width: Math.max(0, window.innerWidth || 0),
      viewport_height: Math.max(0, window.innerHeight || 0),
      screen_width: window.screen ? Math.max(0, window.screen.width || 0) : 0,
      screen_height: window.screen ? Math.max(0, window.screen.height || 0) : 0,
      device_pixel_ratio: window.devicePixelRatio || 1
    };
  }

  function updateScrollPercent() {
    try {
      var doc = document.documentElement;
      var body = document.body;
      var scrollTop = window.pageYOffset || doc.scrollTop || body.scrollTop || 0;
      var height = Math.max(
        body ? body.scrollHeight : 0,
        doc ? doc.scrollHeight : 0,
        body ? body.offsetHeight : 0,
        doc ? doc.offsetHeight : 0
      );
      var viewport = window.innerHeight || doc.clientHeight || 0;
      var denominator = Math.max(1, height - viewport);
      var percent = Math.min(100, Math.max(0, Math.round((scrollTop / denominator) * 100)));
      if (height <= viewport) percent = 100;
      maxScrollPercent = Math.max(maxScrollPercent, percent);
    } catch (e) {}
  }

  // Visible time stops after 60 seconds without input; heartbeats never renew activity.
  function tick() {
    var at = monotonicNow();
    if (document.visibilityState === 'visible' && visibleStart !== null) {
      engagedMs += Math.max(0, Math.min(at, lastActivity + 60000) - lastTick);
    }
    lastTick = at;
  }
  function stopVisible() { tick(); visibleStart = null; }
  function startVisible() { lastTick = monotonicNow(); visibleStart = lastTick; }
  function activity() {
    tick();
    var nextActivity = monotonicNow();
    var restarted = nextActivity - lastActivity >= 1800000;
    if (restarted) sendSummary();
    lastActivity = nextActivity;
    if (restarted) sendSummary();
  }
  ['pointerdown', 'keydown', 'touchstart', 'scroll'].forEach(function (type) {
    document.addEventListener(type, activity, { passive: true });
  });

  function targetMetadata(url) {
    try {
      return {
        target_host: truncate(url.host || ''),
        target_protocol: truncate((url.protocol || '').replace(':', ''), 32),
        target_path: truncate(url.pathname || '/', 255)
      };
    } catch (e) {
      return {};
    }
  }

  function elementMetadata(element, event) {
    var metadata = {};

    try {
      if (!element || !element.getAttribute) return metadata;

      var bucket = element.getAttribute('data-website-click-bucket')
        || element.getAttribute('data-ads-event')
        || element.getAttribute('data-website-goal')
        || '';
      var goalKey = element.getAttribute('data-website-goal')
        || element.getAttribute('data-ads-event')
        || '';
      var selector = '';

      if (element.id) {
        selector = '#' + element.id;
      } else if (element.getAttribute('data-website-goal')) {
        selector = '[data-website-goal="' + element.getAttribute('data-website-goal') + '"]';
      }

      metadata.element_tag = truncate((element.tagName || '').toLowerCase(), 40);
      metadata.element_id = truncate(element.id || '', 100);
      metadata.element_classes = truncate(typeof element.className === 'string' ? element.className : '', 180);
      metadata.click_bucket = truncate(bucket || metadata.element_tag || 'click', 120);
      metadata.goal_key = truncate(goalKey || '');
      metadata.goal_label = truncate(element.getAttribute('data-website-goal-label') || element.getAttribute('data-ads-event-label') || '');
      metadata.selector = truncate(selector, 180);

      if (event && typeof event.clientX === 'number' && typeof event.clientY === 'number') {
        metadata.click_x_pct = Math.max(0, Math.min(100, Math.round((event.clientX / Math.max(1, window.innerWidth || 1)) * 100)));
        metadata.click_y_pct = Math.max(0, Math.min(100, Math.round((event.clientY / Math.max(1, window.innerHeight || 1)) * 100)));
      }
    } catch (e) {}

    return metadata;
  }

  function mergeMetadata() {
    var merged = {};
    for (var i = 0; i < arguments.length; i += 1) {
      var source = arguments[i] || {};
      Object.keys(source).forEach(function (key) {
        if (source[key] !== null && typeof source[key] !== 'undefined' && source[key] !== '') {
          merged[key] = source[key];
        }
      });
    }
    return merged;
  }

  function downloadable(url) {
    try {
      return /\.(pdf|doc|docx|xls|xlsx|ppt|pptx|zip|csv|txt|jpg|jpeg|png|webp)$/i.test(url.pathname || '');
    } catch (e) {
      return false;
    }
  }

  function classifyLink(link) {
    var href = link && link.getAttribute ? link.getAttribute('href') : null;
    if (!href) return null;

    try {
      var url = new URL(href, window.location.href);
      var adsEvent = link.getAttribute('data-ads-event') || '';
      if (link.hasAttribute('data-app-link') || adsEvent === 'app_link_click') return { type: 'app_link_click', url: url };
      if (url.protocol === 'mailto:') return { type: 'mailto_click', url: url };
      if (url.protocol === 'tel:') return { type: 'tel_click', url: url };
      if (url.protocol === 'itms-apps:' || url.protocol === 'market:') return { type: 'app_link_click', url: url };
      if ((url.hostname || '').match(/(^|\.)apps\.apple\.com$|(^|\.)play\.google\.com$/i)) return { type: 'app_link_click', url: url };
      if (!['http:', 'https:', 'mailto:', 'tel:', 'javascript:'].includes(url.protocol)) return { type: 'app_link_click', url: url };
      if (downloadable(url)) return { type: 'download_click', url: url };
      if ((url.protocol === 'http:' || url.protocol === 'https:') && url.host !== window.location.host) {
        return { type: 'outbound_click', url: url };
      }
    } catch (e) {}

    return null;
  }

  function closestForm(target) {
    try {
      return target && target.closest ? target.closest('form') : null;
    } catch (e) {
      return null;
    }
  }

  function formSeen(form) {
    if (!form) return true;
    if (formStarts) {
      if (formStarts.has(form)) return true;
      formStarts.add(form);
      return false;
    }
    if (formStartFallback.indexOf(form) !== -1) return true;
    formStartFallback.push(form);
    return false;
  }

  function formMetadata(form) {
    var action = null;
    try {
      var actionUrl = new URL(form.getAttribute('action') || window.location.pathname, window.location.href);
      action = actionUrl.pathname || '/';
    } catch (e) {}

    return {
      form_id: truncate(form.getAttribute('id') || ''),
      form_name: truncate(form.getAttribute('name') || ''),
      form_action: truncate(action),
      form_method: truncate((form.getAttribute('method') || 'get').toLowerCase(), 20)
    };
  }

  updateScrollPercent();
  sendEvent('page_loaded', { metadata: dimensionsMetadata() });

  window.addEventListener('scroll', updateScrollPercent, { passive: true });
  window.addEventListener('resize', updateScrollPercent, { passive: true });

  document.addEventListener('click', function (event) {
    var target = event.target;
    var link = target && target.closest ? target.closest('a[href]') : null;
    var ctaTarget = target && target.closest ? target.closest('[data-website-goal], [data-ads-event], [data-website-click-bucket]') : null;
    var classified = classifyLink(link);

    if (ctaTarget) {
      counts.cta += 1;
      sendEvent('cta_click', {
        metadata: mergeMetadata(elementMetadata(ctaTarget, event), link && classified ? targetMetadata(classified.url) : {})
      });
    }

    if (!classified) return;

    if (classified.type === 'outbound_click') counts.outbound += 1;
    if (classified.type === 'app_link_click') counts.app += 1;
    if (classified.type === 'mailto_click') counts.mailto += 1;
    if (classified.type === 'tel_click') counts.tel += 1;
    if (classified.type === 'download_click') counts.download += 1;

    sendEvent(classified.type, {
      event_url: truncate(classified.url.href, 2000),
      metadata: mergeMetadata(targetMetadata(classified.url), elementMetadata(link, event))
    });

    if (classified.type === 'app_link_click' && typeof window.ponoAdsEvent === 'function') {
      window.ponoAdsEvent('app_link_click', {
        event_label: link ? (link.getAttribute('data-website-goal-label') || link.getAttribute('data-ads-event-label') || '') : '',
        metadata: mergeMetadata(targetMetadata(classified.url), elementMetadata(link, event))
      });
    }
  }, true);

  function recordFormStart(event) {
    var form = closestForm(event.target);
    if (!form || formSeen(form)) return;
    counts.form += 1;
    sendEvent('form_start', { metadata: formMetadata(form) });
  }

  document.addEventListener('focusin', recordFormStart, true);
  document.addEventListener('click', recordFormStart, true);
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches('form')) return;
    sendEvent('form_submit_attempt', { metadata: formMetadata(form) });
  }, true);

  document.addEventListener('copy', function () {
    counts.copy += 1;
    if (!copyEventSent) {
      copyEventSent = true;
      sendEvent('copy', { metadata: { copy_count: counts.copy } });
    }
  }, true);

  window.addEventListener('beforeprint', function () {
    counts.print += 1;
    sendEvent('print', { metadata: { print_count: counts.print } });
  });

  function summaryMetadata() {
    tick();
    updateScrollPercent();
    return {
      engaged_ms: Math.floor(engagedMs),
      last_activity_age_ms: Math.max(0, Math.floor(monotonicNow() - lastActivity)),
      total_ms: Math.max(0, Date.now() - startedAt),
      max_scroll_percent: maxScrollPercent,
      copy_count: counts.copy,
      print_count: counts.print,
      outbound_click_count: counts.outbound,
      app_link_click_count: counts.app,
      cta_click_count: counts.cta,
      mailto_click_count: counts.mailto,
      tel_click_count: counts.tel,
      download_click_count: counts.download,
      form_count: counts.form
    };
  }

  function sendSummary() {
    sendEvent('engagement_summary', { metadata: summaryMetadata() });
  }

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') {
      startVisible();
      activity();
      hiddenSent = false;
      return;
    }

    stopVisible();
    if (!hiddenSent) {
      hiddenSent = true;
      sendEvent('visibility_hidden', { metadata: { visibility_state: 'hidden' } });
    }
    sendSummary();
  });

  window.setInterval(function () {
    if (document.visibilityState === 'visible' && monotonicNow() - lastActivity <= 60000) sendSummary();
  }, 15000);
  window.addEventListener('pagehide', function () { stopVisible(); sendSummary(); });
  window.addEventListener('pageshow', function (event) {
    if (event.persisted && document.visibilityState === 'visible') startVisible();
  });
  return { sendSummary: sendSummary };
});
